import React from "react";
import { withFormik, Form, Field } from "formik";
import { FormGroup, Label, Button, Col } from "reactstrap";
import { toast } from "react-toastify";
import axios from "../../services/api/api";
import { API_BASE_URL } from "../../constants/api.constants";
import { FormattedMessage } from "react-intl";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";

const AddModuleToCourseForm = ({
  errors,
  touched,
  isSubmitting,
  modules,
  dismissModal,
}) => {
  return (
    <div className="col-12 col-sm-12">
      <Form>
        <FormGroup row>
          <Label lg={3}>
            <span className="fa fa-play-circle-o" />
            &nbsp;Modul
          </Label>

          <Col lg={5} className="">
            <Field
              component="select"
              name="moduleId"
              id="moduleIdSelect"
              className={`form-control ${
                errors.moduleId && touched.moduleId && "is-invalid"
              }`}
            >
              <option value="-1" key="-1">
                -- Välj en modul från listan --
              </option>

              {modules
                .sort((a, b) =>
                  a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                )
                .map((c) => {
                  return (
                    <option key={c.id} value={c.id}>
                      {c.name} -{" "}
                      {c.url.includes("Scormfiles/")
                        ? c.url.split("Scormfiles/")[1]
                        : c.url}
                    </option>
                  );
                })}
            </Field>
            {errors.moduleId && touched.moduleId && (
              <div className="invalid-feedback">{errors.moduleId}</div>
            )}
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label lg={3}>
            <span className="fa fa-bullseye" />
            &nbsp;Sort order
          </Label>
          <Col lg={3}>
            <Field
              className={`form-control ${
                errors.sortOrder && touched.sortOrder && "is-invalid"
              }`}
              type="input"
              name="sortOrder"
            />
            {errors.sortOrder && touched.sortOrder && (
              <div className="invalid-feedback">{errors.sortOrder}</div>
            )}
          </Col>
        </FormGroup>
        <Button
          outline
          color="primary"
          type="submit"
          className="float-end"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Vänta..." : "Spara"}
        </Button>
        <Button
          outline
          color="secondary"
          className="float-end me-2"
          onClick={() => dismissModal()}
        >
          <FormattedMessage id="Cancel" />
        </Button>
      </Form>
    </div>
  );
};

const FormikForm = withFormik({
  enableReinitialize: true,
  mapPropsToValues: (props, name) => {
    return {
      dismissModal: props.dismissModal,
      name: name || "",
      modules: props.modules,
      createFromSelect: true,
      createNew: false,
      courseId: props.courseId,
      sortOrder: 0,
      moduleId: -1,
      selectModule: props.selectModule !== null ? props.selectModule : -1,
    };
  },

  handleSubmit(values, { props, setSubmitting }) {
    //Koppla vald modul till kurs
    if (values.createFromSelect) {
      axios
        .post(
          `${API_BASE_URL}/Course/AddExistingModuleToCourse?courseId=${values.courseId}&moduleId=${values.moduleId}&sortOrder=${values.sortOrder}`,
          {}
        )
        .then(() => {
          toast.success("Modulen har lagts till kursen", TOAST_CONFIG);
          props.reloadModules();
          props.dismissModal();
        })
        .catch((err) => {
          toast.warn(err.response.data, TOAST_CONFIG);
          props.dismissModal();
        });
    }

    setSubmitting(false);
  },
})(AddModuleToCourseForm);

export default FormikForm;
